import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedAdminRoute = ({ children }) => {
  const { admin, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="admin-loading"
        className="min-h-screen flex items-center justify-center bg-[#F4F8FB]"
      >
        <div className="flex items-center gap-3 text-[#173A5E]">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span className="font-[Poppins] font-medium">Beheer laden…</span>
        </div>
      </div>
    );
  }

  if (!admin) {
    return (
      <Navigate
        to="/beheer/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }
  return children;
};

export default ProtectedAdminRoute;
